import React from "react";
import { useLoaderData, Await, useParams, useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { CMAddressBook, GetCampaignsListResponse } from "services/apiService";
import Box from "@mui/material/Box";
import CampaignsDatagrid from "views/campaign/CampaignsDatagridVERSION2";
import Typography from "@mui/material/Typography";
import BACKUPDATAGRID from "views/campaign/BACKUP-CAMPAIGN-DATAGRID";

export enum HomeAction {
    DeleteContacts = "DELETE_CONTACTS",
    AddContact = "ADD_CONTACTS",
    ScheduleCampaing = "SCHEDULE_CAMPAING",
    DeleteCampaing = "DELETE_CAMPAING",
    CancelScheduled= "CANCEL_SCHEDULE",
}

const Home = () => {
    const loaderData = useLoaderData() as {
        data: Promise<[GetCampaignsListResponse, CMAddressBook[]]>;
    };
    console.log("\t # useparams :", useParams());
    const location = useLocation();
    const { campagnesFiltrees } = location.state || {};
    console.log("\t # campagnesFiltrees :", location);

    return (
        // Loading indicator while fetching stats data
        <React.Suspense
            fallback={
                <Box
                    sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <CircularProgress />
                    <p>Loading campaigns and addressBooks data...</p>
                </Box>
            }
        >
            <Await
                resolve={loaderData.data}
                errorElement={<p>Error while loading campaigns or addressBooks data</p>}
            >
                <Typography variant="h6">
                    <span>All Campaings</span>
                </Typography>
                <br />
                <BACKUPDATAGRID cm_status={"draft"} />
            </Await>
        </React.Suspense>
    );
};

export default Home;
